import { jsx as t } from "react/jsx-runtime";
import i from "../../utils/classNames.js";
const l = (s) => {
  const { className: a = "", shadow: d = "default", padding: r = 15, children: e, ...o } = s, n = i("bg-white", "rounded", "border", `shadow-${d}`, `padding-${r}`, a);
  return /* @__PURE__ */ t("div", { ...o, className: n, children: e });
};
export {
  l as default
};
//# sourceMappingURL=Card.js.map
